export function NotFound() {
  return <main>Not found</main>;
}
